/**
 * idetox ブログ本文フォーム埋め込みローダー (form-embed.js)
 *
 * 目的:
 *   Shopifyのブログ本文はLiquidが効かない（{% render %} 不可）ため、
 *   本文には「プレースホルダのHTML」だけを置き、フォーム本体は
 *   テーマ側でLiquidが生成した隠し <template> から複製して注入する。
 *
 * 著者の使い方（ブログ記事のHTML本文に貼るだけ）:
 *   <div data-idetox-form="business"></div>
 *   <div data-idetox-form="business" data-cta="blog_xxx_article"></div>
 *   <div data-idetox-form="sauna"></div>     ← 対応テンプレート追加後に有効
 *   <div data-idetox-form="contact"></div>   ← 対応テンプレート追加後に有効
 *
 * 仕組み:
 *   1. snippets/blog-form-embeds.liquid が <template id="idetox-form-tmpl-KEY"> と
 *      各フォームのCSS/JSを（本文に該当プレースホルダがある時だけ）出力する。
 *   2. このスクリプトが [data-idetox-form] を探し、対応テンプレートを複製して注入。
 *   3. 各フォームJSが公開する初期化関数 window.idetox{Key}FormInit(scope) を呼ぶ。
 *
 * 注意:
 *   - 各フォームJSは単一インスタンス前提のため、1記事につき同種フォームは1個まで。
 *   - 種類の異なるフォームを複数並べるのは可。
 */
(function () {
  'use strict';

  // フォームキー → 各フォームJSが window に公開する初期化関数名
  var INITIALIZERS = {
    business: 'idetoxBusinessFormInit',
    sauna: 'idetoxSaunaFormInit',
    contact: 'idetoxContactFormInit'
  };

  function callInit(key, scope) {
    var name = INITIALIZERS[key];
    var fn = name ? window[name] : null;
    if (typeof fn === 'function') {
      try {
        fn(scope);
      } catch (e) {
        if (window.console) console.warn('[idetox form-embed] 初期化に失敗:', key, e);
      }
      return true;
    }
    return false;
  }

  function mount(placeholder) {
    if (placeholder.getAttribute('data-idetox-mounted') === '1') return;

    var key = placeholder.getAttribute('data-idetox-form');
    if (!key) return;

    var tmpl = document.getElementById('idetox-form-tmpl-' + key);
    if (!tmpl || !('content' in tmpl)) {
      if (window.console) console.warn('[idetox form-embed] テンプレート未検出:', key);
      return;
    }

    var fragment = tmpl.content.cloneNode(true);

    // data-accordion="ラベル" 指定時は <details> でラップ（その場で開閉するCTA）
    var accordionLabel = placeholder.getAttribute('data-accordion');
    if (accordionLabel) {
      var details = document.createElement('details');
      details.className = 'idetox-embed-accordion';
      var summary = document.createElement('summary');
      summary.className = 'idetox-embed-accordion__summary';
      summary.textContent = accordionLabel;
      details.appendChild(summary);
      details.appendChild(fragment);
      placeholder.appendChild(details);
    } else {
      placeholder.appendChild(fragment);
    }
    placeholder.setAttribute('data-idetox-mounted', '1');

    // プレースホルダの data-cta を hidden の cta_label へ受け渡し（任意）
    var cta = placeholder.getAttribute('data-cta');
    if (cta) {
      var ctaField = placeholder.querySelector('[name="cta_label"]');
      if (ctaField) ctaField.value = cta;
    }

    // 初期化（フォームJSの読み込み順により init 未定義の可能性があるため軽くリトライ）
    if (!callInit(key, placeholder)) {
      var tries = 0;
      var timer = setInterval(function () {
        tries++;
        if (callInit(key, placeholder) || tries > 20) clearInterval(timer);
      }, 100);
    }
  }

  function hydrate() {
    var nodes = document.querySelectorAll('[data-idetox-form]');
    for (var i = 0; i < nodes.length; i++) mount(nodes[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hydrate);
  } else {
    hydrate();
  }
})();
